export class ListasTerceros {
  terceros: string[] = [];
  usuarios: string[] = [];
  conflictos: string[] = [];
}
